import { Page } from "@/models/page-models/Page";

export const DailyVatReport: Page = {
  "path": "daily-vat-report",
  "name": "Daily VAT Report",
  "props": {
    "data": {
      "title": "Daily VAT Report",
      "printable": "TRUE",
      "url": "daily-vat-report",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Report",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "getDailyVatReport"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                },
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.dailyVAT}}",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Daily VAT Report",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.dailyVAT}}",
                  "items": "fetchedData.dailyVAT.data",
                  "headers": [
                    {
                      "value": "typeIdOrInvoiceNo",
                      "text": "Doc #",
                      "type": "url",
                      "url": "fn(CONDITIONAL,{{'{{__item.invpType}}'=='Credit Note'}},/credit-note/{{__item.invoiceNo}},/invoice/{{__item.invoiceNo}})"
                    },
                    {
                      "value": "loadingManifestNo",
                      "text": "Loading Manifest #"
                    },
                    {
                      "value": "type",
                      "text": "Type"
                    },
                    {
                      "value": "transactionDate",
                      "text": "Transaction Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.transactionDate}})"
                    },
                    {
                      "value": "customerId",
                      "text": "Customer Id"
                    },
                    {
                      "value": "customerName",
                      "text": "Customer"
                    },
                    {
                      "value": "customerRegion",
                      "text": "Region"
                    },
                    {
                      "value": "subTotalSR",
                      "text": "Subtotal SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__item.type}}}},'),==,'INVP'),fn(SUBTRACT,0,fn(SUBTRACT,{{__item.totalSR}},{{__item.vatSR}})),fn(SUBTRACT,{{__item.totalSR}},{{__item.vatSR}})))"
                    },
                    {
                      "value": "vatSR",
                      "text": "VAT SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__item.type}}}},'),==,'INVP'),fn(SUBTRACT,0,{{__item.vatSR}}),{{__item.vatSR}}))"
                    },
                    {
                      "value": "totalSR",
                      "text": "Total SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__item.type}}}},'),==,'INVP'),fn(SUBTRACT,0,{{__item.totalSR}}),{{__item.totalSR}}))"
                    }
                  ],
                  "tableType": "static",
                  "enableGoogleSheetExport": true,
                  "googlSheetFileName": "Daily VAT Report (From {{formData.startDate}} - {{formData.endDate}})",
                  "footer": {
                    "subTotalSR": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__arrayItem.type}}}},'),==,'INVP'),fn(SUBTRACT,0,fn(SUBTRACT,{{__arrayItem.totalSR}},{{__arrayItem.vatSR}})),fn(SUBTRACT,{{__arrayItem.totalSR}},{{__arrayItem.vatSR}})),{{fetchedData.dailyVAT.data}},typeIdOrInvoiceNo))",
                    "vatSR": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__arrayItem.type}}}},'),==,'INVP'),fn(SUBTRACT,0,{{__arrayItem.vatSR}}),{{__arrayItem.vatSR}}),{{fetchedData.dailyVAT.data}},typeIdOrInvoiceNo))",
                    "totalSR": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__arrayItem.type}}}},'),==,'INVP'),fn(SUBTRACT,0,{{__arrayItem.totalSR}}),{{__arrayItem.totalSR}}),{{fetchedData.dailyVAT.data}},typeIdOrInvoiceNo))",
                    "customerName": "Grand Total"
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "functions": [
      {
        "name": "getDailyVatReport",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/reports/daily-vat?endDate={{formData.endDate}}&startDate={{formData.startDate}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.dailyVAT"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": true,
  "menuGroup": "Reports"
}